const Api = {
    // BASEURL: "http://localhost:3001/api",
    BASEURL: "https://cpos.customersync.ai/backend",
};
export default Api;